import { render, staticRenderFns } from "./AppointmentCreatedToUser.vue?vue&type=template&id=543bd278"
import script from "./AppointmentCreatedToUser.vue?vue&type=script&lang=js"
export * from "./AppointmentCreatedToUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports